var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var LayerService = /** @class */ (function () {
    function LayerService() {
    }
    LayerService.prototype.getMaxZOrder = function (dataArray) {
        var zOrder = 0;
        if (dataArray.length > 0) {
            if (dataArray[0].zOrder) {
                zOrder = dataArray[0].zOrder;
            }
        }
        dataArray.forEach(function (data) {
            if (data.zOrder) {
                if (zOrder < data.zOrder) {
                    zOrder = data.zOrder;
                }
            }
        });
        return zOrder;
    };
    LayerService.prototype.getMinZOrder = function (dataArray) {
        var zOrder = 0;
        if (dataArray.length > 0) {
            if (dataArray[0].zOrder) {
                zOrder = dataArray[0].zOrder;
            }
        }
        dataArray.forEach(function (data) {
            if (data.zOrder) {
                if (zOrder > data.zOrder) {
                    zOrder = data.zOrder;
                }
            }
        });
        return zOrder;
    };
    LayerService = __decorate([
        Injectable()
    ], LayerService);
    return LayerService;
}());
export { LayerService };
